import { render, staticRenderFns } from "./OptionalGroup.vue?vue&type=template&id=9fef5d48"
import script from "./OptionalGroup.vue?vue&type=script&lang=js"
export * from "./OptionalGroup.vue?vue&type=script&lang=js"
import style0 from "./OptionalGroup.vue?vue&type=style&index=0&id=9fef5d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports